module.exports = __webpack_public_path__ + "img/unit1.d8e6f60a.jpg";